module.exports = __webpack_public_path__ + "img/list3.9a8adbb0.png";